import React from 'react'
import Header from '../Components/Header'
import ReferenceUpload from '../Components/RefUpload'
import { Link } from 'react-router-dom'

const ReferenceStructuring = () => {
  return (
    <div>
             <div className="w-full bg-white flex justify-center sticky top-0 bg-white z-20 border-b-[1px] border-gray-200">
        <div className="2xl:container w-full mx-auto">
                <div className="w-full py-3 px-6 sm:px-10 flex justify-between h-fit sm:h-20 relative z-10 ">

               <div className="w-fit sm:w-4/12 h-fit">
                 <div className="  w-fit flex flex-col ">
                   <Link to={"/home"}>
                     <img
                       className="h-[35px] sm:h-[40px]"
                       src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
                       alt="xpress_logo"
                     />
                   </Link>
                   <p className=" text-[8px]  flex gap-1 text-black  justify-end">
                     Powered by
                     <Link target="_blank" to={"https://www.transforma.in/"}>
                       <img
                         className="h-[9px] sm:h-[10px]"
                         src={process.env.PUBLIC_URL + "/images/logos/Transforma.svg"}
                         alt="xpress_logo"
                       />
                     </Link>
                   </p>
                 </div>
               </div>
               </div>
        </div>

      </div>
        <div className="w-full 2xl:container mx-auto">
          <ReferenceUpload />
        </div>
    </div>
  )
}

export default ReferenceStructuring